import React, { useCallback, useEffect, useState } from 'react';
import { taches as apiTaches, messageErreur } from '../services/api';
import { PRIORITES, STATUTS_TACHE, libelle } from '../constants';
import FicheTache from '../components/FicheTache';
import { BadgeEntreprise, BadgePriorite, Chargement, Erreur, useReferentiels } from '../components/communs';
import { dateCourte, enRetard } from '../utils/format';

// Toutes les tâches qui me sont assignées, tous projets confondus,
// triées par priorité puis par échéance.
export default function MesTaches({ moi }) {
  const ref = useReferentiels();
  const [liste, setListe] = useState(null);
  const [erreur, setErreur] = useState(null);
  const [terminees, setTerminees] = useState(false);
  const [priorite, setPriorite] = useState('');
  const [ouverte, setOuverte] = useState(null);

  const charger = useCallback(() => {
    setErreur(null);
    return apiTaches.miennes({ terminees: terminees ? 1 : undefined }).then(setListe).catch((e) => setErreur(messageErreur(e)));
  }, [terminees]);
  useEffect(() => { charger(); }, [charger]);

  const visibles = (liste || []).filter((t) => !priorite || t.priorite === priorite);
  const retard = visibles.filter((t) => enRetard(t.date_echeance, t.statut)).length;

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>Mes tâches</h1>
          <p>Les tâches qui vous sont assignées, de la plus urgente à la moins urgente.{retard > 0 && <> <span className="retard">{retard} en retard.</span></>}</p>
        </div>
      </div>
      <div className="toolbar">
        <div className="segmente" role="group" aria-label="Priorité">
          <button type="button" className={!priorite ? 'actif' : ''} onClick={() => setPriorite('')}>Toutes</button>
          {PRIORITES.map((p) => (
            <button key={p.cle} type="button" className={priorite === p.cle ? 'actif' : ''} onClick={() => setPriorite(p.cle)}>{p.libelle}</button>
          ))}
        </div>
        <label className="bascule" style={{ margin: 0 }}>
          <input type="checkbox" checked={terminees} onChange={(e) => setTerminees(e.target.checked)} />Afficher les terminées
        </label>
      </div>

      {erreur && <Erreur onReessayer={charger}>{erreur}</Erreur>}
      {!liste && !erreur && <Chargement />}
      {liste && visibles.length === 0 && (
        <div className="vide carte">{priorite ? 'Aucune tâche avec cette priorité.' : 'Aucune tâche ne vous est assignée pour l’instant.'}</div>
      )}
      {visibles.length > 0 && (
        <div className="table-container">
          <table className="table-cartes">
            <thead>
              <tr><th>Tâche</th><th>Projet</th><th>Priorité</th><th>Statut</th><th>Échéance</th></tr>
            </thead>
            <tbody>
              {visibles.map((t) => (
                <tr key={t.id} className={`cliquable ${ouverte === t.id ? 'selectionnee' : ''}`} onClick={() => setOuverte(t.id)}>
                  <td style={{ fontWeight: 600 }}>{t.titre}</td>
                  <td>{t.projet_nom}{t.entreprise_nom && <> <BadgeEntreprise nom={t.entreprise_nom} /></>}</td>
                  <td><BadgePriorite priorite={t.priorite} /></td>
                  <td>{libelle(STATUTS_TACHE, t.statut)}</td>
                  <td className={enRetard(t.date_echeance, t.statut) ? 'retard' : ''}>{dateCourte(t.date_echeance) || <span className="faible">—</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {ouverte && (
        <FicheTache
          tacheId={ouverte}
          moi={moi}
          utilisateurs={ref.utilisateurs}
          lienProjet
          onFermer={() => setOuverte(null)}
          onModifie={charger}
        />
      )}
    </div>
  );
}
